/* eslint-disable no-case-declarations */
import {
  SET_REQUEST_REPORT, REQUEST_REPORT_REQUEST_FAILED, SENDING_REQUEST_REPORT_REQUEST,
} from '../../types/Types';

/** @type { Object } default state */
const defaultState = {
  rRData: '',
  isRRSending: false,
  rRError: false,
  isRRSuccess: false,
};

/**
* dispatched the user data to the store
* @param  { Object } state  default state
* @param  { Object } action dispacthed action from middleware
*/
export default function requestReportSubmit(state = defaultState, action = {}) {
  switch (action.type) {
    case SET_REQUEST_REPORT:
      const data = {};
      data.rRData = action.rRData;
      data.isRRSending = action.isRRSending;
      data.isRRSuccess = action.isRRSuccess;
      data.rRError = action.rRError;
      return { ...state, ...data };

    case SENDING_REQUEST_REPORT_REQUEST:
      const sendingRequest = {};
      sendingRequest.rRData = action.rRData;
      sendingRequest.isRRSending = action.isRRSending;
      sendingRequest.isRRSuccess = action.isRRSuccess;
      sendingRequest.rRError = action.rRError;
      return { ...state, ...sendingRequest };

    case REQUEST_REPORT_REQUEST_FAILED:
      const errors = {};
      errors.rRData = action.rRData;
      errors.isRRSending = action.isRRSending;
      errors.isRRSuccess = action.isRRSuccess;
      errors.rRError = action.rRError;
      errors.rRMsg = action.rRMsg;
      return { ...state, ...errors };
    default: return state;
  }
}
